/**
 * @generated SignedSource<<fc6b095c02b49ea340186bc252cf61b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Site_user$data = {
  readonly isLoggedIn: boolean;
  readonly " $fragmentType": "Site_user";
};
export type Site_user$key = {
  readonly " $data"?: Site_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Site_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Site_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLoggedIn",
      "storageKey": null
    }
  ],
  "type": "UserContainer",
  "abstractKey": null
};

(node as any).hash = "01027be8bd619bfee6d2c46245f8df37";

export default node;
